import { observable, action, computed } from "mobx";
import { 
  cm_CONSTANT_entity_tables, ExportSubFunction, ExportCategory, ExportDescription,
  ImportSubFunction 
} from "../constants/constants-container";
import moment from "moment";
import EnvironmentUtils from "src/utils/EnvironmentUtils";
const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";

export default class ExportImportStore {
  @observable bool_showModal = false;
  @observable str_modal_title = "Export";
  @observable str_selectedFunction = "Export";
  @observable selectedExportSubFunction = ExportSubFunction.ENTITY_EXPORT;
  @observable str_exportFileFormat = "xlsx";
  @observable arr_selectedItems = [];
  @observable cubeTypes = [];
  @observable str_selectedImportItem = "Select...";
  @observable str_selectedFrameworkId = "";
  @observable arr_entities = [];
  @observable arr_all_frameworks = [];
  @observable exportCubesByCubeType = true;
  @observable selectedCubeTypes = [];
  /**
   * contains the cube IDs
   */
  @observable selectedCubes = [];
  @observable cubesOfSelectedFramework = [];
  @observable frameworkSelectorOpen = false;
  @observable selectedVariable = "";
  @observable branchToOverrideWorkingBranch = {
    bid: null,
    branchName: "",
    projectName: ""
  };
  @observable cubeHierarchies = [];
  @observable selectedCubeHierarchyIds = [];
  @observable selectedFrameworks = [];
  @observable includeMappingContent = false;
  @observable includeRenderingContent = false;
  @observable includeTransformationContent = false;
  @observable onlyCurrentlyValidMetadata = false;
  @observable frameworkSelectorDisabledForIndividualCubeExport = false;

  DEFAULT_RELEASE_TO_BE_EXPORTED = {
    branchTid: 1,
    label: "PRODUCTION",
    value: 1 + "-PRODUCTION",
  }

  @observable allReleasesOfFramework = [];
  @observable selectedReleaseBranches = [this.DEFAULT_RELEASE_TO_BE_EXPORTED.branchTid];
  @observable validOnDate = null;


  exportTypeWithCsvExportAvailable = [
    ExportSubFunction.ENTITY_EXPORT,
    ExportSubFunction.FRAMEWORKS_EXPORT,
    ExportSubFunction.FRAMEWORK_MODELS_OVERVIEW,
    ExportSubFunction.FRAMEWORK_LOGICAL_LINEAGE,
  ]

  @observable selectedImportSubFunction = ImportSubFunction.SMCUBE;
  @observable filesToImport = []
  @observable indivualCubeImportFrameworkObject = undefined;
  @observable allMaintenanceAgencies = [];
  @observable selectedBranchData = JSON.parse(window.localStorage.getItem(
    "cm-selected-branch"
  ))

  @observable actionsEventsTableData = {
    error: null,
    filter: {},
    metadata: {},
    results: [],
    totalResults: -1,
    type: "",
  };

  @observable
  obj_actionsEventsQueryFilter = {
    type: "Action",
    filter: {
      type: "Action",
      actionType: {in: ["ImportIndividualEntity"]},
      datetime: {
        from: moment()
          .startOf("day")
          .format("YYYY-MM-DDTHH:mm:ss.SSSZZ")
          .toString(),
        until: moment()
          .endOf("day")
          .format("YYYY-MM-DDTHH:mm:ss.SSSZZ")
          .toString(),
      },
      processingStart: {
        from: moment()
          .startOf("day")
          .format("YYYY-MM-DDTHH:mm:ss.SSSZZ")
          .toString(),
        until: moment()
          .endOf("day")
          .format("YYYY-MM-DDTHH:mm:ss.SSSZZ")
          .toString(),
      },
      sort: [],
    },
    limit: {
      limit: 10,
      offset: 0,
    },
  };


  constructor(http, exporter, importer) {
    this.http = http;
    this.exporter = exporter;
    this.importer = importer;
    this.init();
  }

  init = () => {
    this.func_get_entities();
    this.func_fetch_all_frameworks();
    this.str_exportFileFormat = this.getDefaultFileFormatByExportType;
  };

  @action
  changeBranchToOverrideWorkingBranch = (releaseBranchId, releaseBranchName, projectName) => {
    this.branchToOverrideWorkingBranch = {
      bid: releaseBranchId,
      branchName: releaseBranchName,
      projectName: projectName
    }
    
    this.selectedReleaseBranches = [releaseBranchId]
  }

  @action
  func_reset_settings = () => {
    this.str_selectedFunction = "Export";
    this.str_exportFileFormat = this.getDefaultFileFormatByExportType;
    this.arr_selectedItems = [];
    this.str_selectedImportItem = "Select...";
    this.str_selectedFrameworkId = "";
    this.selectedCubeTypes = [];
    this.selectedCubes = [];
    this.cubesOfSelectedFramework = [];
    this.branchToOverrideWorkingBranch = {
      bid: null,
      branchName: "",
      projectName: ""
    };
    this.cubeHierarchies = [];
    this.selectedCubeHierarchyIds = [];
    this.selectedFrameworks = [];
    this.includeMappingContent = false;
    this.includeRenderingContent = false;
    this.includeTransformationContent = false;
    this.onlyCurrentlyValidMetadata = false;
    this.frameworkSelectorDisabledForIndividualCubeExport = false;

    this.allReleasesOfFramework = [];
    this.selectedReleaseBranches = [this.DEFAULT_RELEASE_TO_BE_EXPORTED.branchTid];
    this.validOnDate = null;

    this.filesToImport = [];
    this.indivualCubeImportFrameworkObject = undefined
  };

  @action
  func_get_entities = async () => {
    cm_CONSTANT_entity_tables.forEach((typeGroup, typeGroupIndex) => {
      typeGroup.items.forEach((type, typeIndex) => {
        if(!type.value.includes("prefiltered")) {
          this.arr_entities.push(type);
        }
      })
    })
  };

  @action
  func_close = () => {
    this.bool_showModal = false;
    this.func_reset_settings();
    this.selectedExportSubFunction = ExportSubFunction.ENTITY_EXPORT;
  };

  @action
  func_open = (title) => {
    this.str_modal_title = title;
    this.setValidOnDate(null)
    this.bool_showModal = true;
  };

  @action
  func_resetFileFormatIfNeeded = () => {
    if (this.str_exportFileFormat === "csv") {
      this.str_exportFileFormat = "xlsx";
    }
  };

  @action
  func_handleExportFileFormatChange = newExportFileFormat => {
    this.str_exportFileFormat = newExportFileFormat;
  };

  @action
  changeSelectedExportSubFunction = subFunction => {
    this.selectedExportSubFunction = subFunction;

    this.func_reset_settings();

    // set no validity date by default
    this.setValidOnDate(null)
  };

  @action
  func_handleSelectedFunctionChange = newSelectedFunction => {
    this.func_reset_settings();
    
    this.str_selectedFunction = newSelectedFunction;
  };

  @action
  func_handleSelectedItemsChange = selectedItems => {
    this.arr_selectedItems = selectedItems;
  };

  @action
  handleExportCubesByCubeTypeChange = (value) => {
    this.exportCubesByCubeType = value;
  }

  @action
  handleSelectedCubeTypesChange = (cubeTypes) => {
    this.selectedCubeTypes = cubeTypes;
  }

  @action
  handleSelectedCubesChangeByCubeCode = (cubeCodes) => {
    // a single cube code can match multiple cube IDs. The cube ID contains the version of the cube
    const cubeIdsForCubeCodes = this.cubesOfSelectedFramework.filter(c => cubeCodes.includes(c.value)).map(c => c.cubeId);
    this.selectedCubes = cubeIdsForCubeCodes;
  }

  @action
  handleSelectedCubesChange = (cube) => {
    this.selectedCubes = cube;
  }

  @action
  handleSelectedVariableChange = (variable) => {
    this.selectedVariable = variable;
  }

  @action
  handleSelectedCubeHierarchiesChange = (cubeHierarchyIds) => {
    this.selectedCubeHierarchyIds = cubeHierarchyIds;
  }

  @action
  handleSelectedFrameworksChange = (frameworks) => {
    this.str_selectedFrameworkId = frameworks?.length === 1 ? frameworks[0] : null;
    this.selectedFrameworks = frameworks;

    if (this.selectedExportSubFunction === ExportSubFunction.FRAMEWORK_LOGICAL_LINEAGE) {
      if (EnvironmentUtils.isBirdApp() && !this.selectedFrameworks.map(fw => fw.toLowerCase()).includes("bird")) {
        this.selectedFrameworks.unshift("BIRD");
        this.str_selectedFrameworkId = "BIRD"
      }
    } else {
      if (!frameworks || frameworks.length !== 1) {
        this.allReleasesOfFramework = []
      } else {
        this.fetchFrameworkReleases(this.str_selectedFrameworkId)
      }
      this.selectedReleaseBranches = [this.DEFAULT_RELEASE_TO_BE_EXPORTED.branchTid];
    }
  }

  @action
  toggleIncludeMappingContent = () => {
    this.includeMappingContent = !this.includeMappingContent;
  }

  @action
  toggleIncludeRenderingContent = () => {
    this.includeRenderingContent = !this.includeRenderingContent;
  }

  @action
  toggleIncludeTransformationContent = () => {
    this.includeTransformationContent = !this.includeTransformationContent;
  }

  @action
  toggleAllFrameworkSelection = () => {
    if(this.selectedFrameworks.length === this.arr_all_frameworks.length) {
      this.selectedFrameworks = [];
    } else {
      this.selectedFrameworks = this.arr_all_frameworks.map(fw => fw.value);
    }

    this.selectedReleaseBranches = [this.DEFAULT_RELEASE_TO_BE_EXPORTED.branchTid]
    this.allReleasesOfFramework = []
  }

  @action
  disableFrameworkSelectorForIndividualCubeExport = () => {
    this.frameworkSelectorDisabledForIndividualCubeExport = true;
  }

  @action
  func_fetch_all_frameworks = () => {
    this.http.service_query_all_Frameworks().then(
      action(frameworks => {
        if (frameworks?.results) {
          this.arr_all_frameworks = frameworks.results.map(entity => ({
            label: entity.name,
            value: entity.frameworkId,
            fwId: entity.tid,
            code: entity.code
          }));
        } else {
          this.arr_all_frameworks = [];
        }
      })
    );
  };

  @action
  fetchCubesOfSelectedFramework = (branchTid) => {
    const cubeFilter = {
      type: "Cube",
      filter: {
        frameworkId: {
          in: [this.str_selectedFrameworkId]
        },
        bid: {
          in: branchTid ? [branchTid] : [1]
        },
        effectiveTo: {
          isNull: true
        },
        type: "Cube"
      }
    };
    this.http.service_fetch_filteredEntities(cubeFilter, response => {
      const uniqueCubeIds = [];
      if(response && response.results) {
        const alreadyPresentCubes = [...this.cubesOfSelectedFramework];
        response.results.forEach(cube => {
          if(!uniqueCubeIds.includes(cube.cubeId)) {
            uniqueCubeIds.push(cube.cubeId);
            alreadyPresentCubes.push(
              {
                label: cube.name,
                value: cube.code,
                cubeId: cube.cubeId,
                validFrom: cube.validFrom
              }
            )

          }
        });
        this.cubesOfSelectedFramework = alreadyPresentCubes;
      } else {
        this.cubesOfSelectedFramework = [];
      }
    });
  }

  @action
  fetchCubeHierarchies = (frameworkId, branchTid) => {
    let cubeHierarchyFilter = null;
    if(frameworkId !== undefined) {
      cubeHierarchyFilter = {
        type: "CubeHierarchy",
        filter: {
          frameworkId: {
            in: [frameworkId]
          },
          type: "CubeHierarchy"
        }
      };
    } else {
      cubeHierarchyFilter = {
        type: "CubeHierarchy",
        filter: {
          type: "CubeHierarchy"
        },
      };
    }
    cubeHierarchyFilter.filter.bid = {
      in: branchTid ? [branchTid] : [1]
    }
    this.http.service_fetch_filteredEntities(cubeHierarchyFilter, response => {
      const uniqueCubeHierarchyIds = [];
      if(response && response.results) {
        response.results.forEach(cubeHierarchy => {
          if(!uniqueCubeHierarchyIds.includes(cubeHierarchy.cubeHierarchyId)) {
            uniqueCubeHierarchyIds.push(cubeHierarchy.cubeHierarchyId);
            this.cubeHierarchies.push(
              {
                label: cubeHierarchy.name,
                value: cubeHierarchy.cubeHierarchyId
              }
            )

          }
        });
      } else {
        this.cubeHierarchies = [];
      }
    }); 
  }

  @action
  func_handleFrameworkChange = (selectedFrameworkId, overrideBranchTid) => {
    this.str_selectedFrameworkId = selectedFrameworkId;
    this.selectedReleaseBranches = overrideBranchTid ? [overrideBranchTid] : [this.DEFAULT_RELEASE_TO_BE_EXPORTED.branchTid];

    if (this.selectedExportSubFunction === ExportSubFunction.INDIVIDUAL_CUBE_EXPORT) {
      this.cubesOfSelectedFramework = []
      this.selectedCubes = []
      this.fetchCubesOfSelectedFramework(this.getSelectedReleaseOfFramework);
      this.fetchFrameworkReleases(selectedFrameworkId)
    } else if (this.selectedExportSubFunction === ExportSubFunction.FRAMEWORK_MATRIX_EXPORT) {
      this.cubeHierarchies = []
      this.selectedCubeHierarchyIds = []
      this.fetchCubeHierarchies(selectedFrameworkId, this.getSelectedReleaseOfFramework);
      this.fetchFrameworkReleases(selectedFrameworkId)
    } else if (this.selectedExportSubFunction === ExportSubFunction.FRAMEWORK_DELTA_COMPARISON) {
      this.fetchFrameworkReleases(selectedFrameworkId)
    }
  };

  @action
  toggleFrameworkSelectorOpen = () => {
    this.frameworkSelectorOpen = !this.frameworkSelectorOpen;
  }

  @action
  handleIndividualCubeExportFromCM = (selectedCubes, isUserDa, workingBranchId) => {
    this.func_open(isUserDa && workingBranchId !== null ? "Export/Import" : "Export");
    this.changeSelectedExportSubFunction(ExportSubFunction.INDIVIDUAL_CUBE_EXPORT);
    this.func_handleFrameworkChange(selectedCubes[0].frameworkId);
    this.handleExportCubesByCubeTypeChange(false);
    this.handleSelectedCubesChange(selectedCubes.map(cube => cube.cubeId));
  }

  @action
  handleIndividualCubeExportFromReleaseManagement = (frameworkId, isUserDa, workingBranchId, releaseBranchTid) => {
    this.func_open(isUserDa && workingBranchId !== null ? "Export/Import" : "Export");
    this.changeSelectedExportSubFunction(ExportSubFunction.INDIVIDUAL_CUBE_EXPORT);
    this.func_handleFrameworkChange(frameworkId, releaseBranchTid);
  }

  @action
  toggleOnlyCurrentlyValidMetadataChange = () => {
    this.onlyCurrentlyValidMetadata = !this.onlyCurrentlyValidMetadata;
  }

  @action
  handleFrameworkMatrixExportFromCM = (selectedCubeHierarchyIds, isUserDa, workingBranchId) => {
    this.func_open(isUserDa && workingBranchId !== null ? "Export/Import" : "Export");
    this.changeSelectedExportSubFunction(ExportSubFunction.FRAMEWORK_MATRIX_EXPORT);
    this.fetchCubeHierarchies();
    this.handleSelectedCubeHierarchiesChange(selectedCubeHierarchyIds);
  }

  @action
  handleFrameworkMatrixExportFromReleaseManagement = (isUserDa, workingBranchId, frameworkId, releaseBranchTid) => {
    this.func_open(isUserDa && workingBranchId !== null ? "Export/Import" : "Export");
    this.changeSelectedExportSubFunction(ExportSubFunction.FRAMEWORK_MATRIX_EXPORT);
    this.func_handleFrameworkChange(frameworkId, releaseBranchTid);
  }

  setSelectedBranchIdInExporterAndImporter = (selectedBranchObject) => {
    this.setSelectedBranchData(selectedBranchObject);
    this.exporter.setSelectedBranchId(selectedBranchObject.branch.tid);
    this.importer.setSelectedBranchId(selectedBranchObject.branch.tid);
  }

  exportSelectedEntitiesFromCM = (tids, entityWithSddPrefix) => {
    this.exporter.exportEntitiesByTid(tids, entityWithSddPrefix);
  }

  @action
  func_handleExportClick = () => {
    let exportParameters = {
      selectedExportSubFunction: this.selectedExportSubFunction,
      selectedItems: this.arr_selectedItems,
      selectedCubeTypes: this.selectedCubeTypes,
      selectedCubes: this.selectedCubes,
      selectedVariable: this.selectedVariable,
      selectedFramework: this.arr_all_frameworks.filter(fw => this.str_selectedFrameworkId === fw.value)[0],
      selectedFrameworks: this.selectedFrameworks,
      includeMappingContent: this.includeMappingContent,
      includeRenderingContent: this.includeRenderingContent,
      includeTransformationContent: this.includeTransformationContent,
      fileFormat: this.str_exportFileFormat,
      branchIdToOverrideWorkingBranchId: this.branchToOverrideWorkingBranch.bid,
      selectedCubeHierarchies: this.cubeHierarchies.filter(ch => this.selectedCubeHierarchyIds.includes(ch.value)),
      onlyCurrentlyValidMetadata: this.onlyCurrentlyValidMetadata,
      selectedRelease: this.getSelectedReleaseOfFramework !== 1 ? this.getReleaseDetailsByBranchTid(this.getSelectedReleaseOfFramework) : null,
      validOnDate: this.validOnDate
    };
    this.exporter.export(exportParameters);
    this.func_close();
  };

  @action
  handleImportClick = () => {
    const importParam = {};
    if (this.branchToOverrideWorkingBranch && this.branchToOverrideWorkingBranch.bid) {
      importParam.specificBranch = this.branchToOverrideWorkingBranch.bid
    }

    if (this.selectedImportSubFunction === ImportSubFunction.SMCUBE) {
      importParam.csvItem = this.get_str_selectedImportItem?.toLowerCase() ?? "";
    } else if (this.selectedImportSubFunction === ImportSubFunction.INDIVIDUAL_ENTITY) {
      importParam.maintenanceAgencyId = this.getIndividualCubeImportMaintenanceAgencyId
      importParam.selectedFrameworkCode = this.getIndividualCubeImportFramework
    }

    this.filesToImport.forEach(file => {
      this.importer.import(file, this.selectedImportSubFunction, importParam);
    })
    this.func_close();
  }

  @action
  func_handleImportItemSelect = newImportItem => {
    this.str_selectedImportItem = newImportItem;
  };

  func_uppercaseFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  @computed
  get get_bool_showModal() {
    return this.bool_showModal;
  }

  @computed
  get areExportSettingsProperlyConfigured() {
    switch(this.selectedExportSubFunction) {
      case ExportSubFunction.ENTITY_EXPORT:
        return true;
      case ExportSubFunction.FRAMEWORKS_EXPORT:
        if(this.selectedFrameworks.length > 0) {
          return true;
        }
        return false;
      case ExportSubFunction.FRAMEWORK_MATRIX_EXPORT:
        if(this.selectedCubeHierarchyIds.length > 0) {
          return true;
        }
        return false;
      case ExportSubFunction.INDIVIDUAL_CUBE_EXPORT:
        if (this.str_selectedFrameworkId !== "" && ((this.exportCubesByCubeType && this.selectedCubeTypes.length > 0) || (!this.exportCubesByCubeType && this.selectedCubes.length > 0))) {
          return true;
        }
        return false;
      case ExportSubFunction.FRAMEWORK_LOGICAL_LINEAGE:
          if (this.selectedFrameworks.length > 0) {
            return true;
          }
          return false;
      case ExportSubFunction.FRAMEWORK_MODELS_OVERVIEW:
        if (this.str_selectedFrameworkId && this.str_selectedFrameworkId !== "") {
          return true;
        }
        return false;
      case ExportSubFunction.FRAMEWORK_DELTA_COMPARISON:
        if (this.str_selectedFrameworkId && this.str_selectedFrameworkId !== "") {
          return true;
        }
        return false;
      default:
        return false;
    }
  }

  @computed
  get areImportSettingsProperlyConfigured() {
    switch(this.selectedImportSubFunction) {
      case ImportSubFunction.SMCUBE:
        return true;
      default:
        return false;
    }
  }

  @computed
  get get_str_selectedFunction() {
    return this.str_selectedFunction;
  }

  @computed
  get get_bool_exportMultipleItems() {
    return this.bool_exportMultipleItems;
  }

  @computed
  get get_str_exportFileFormat() {
    return this.str_exportFileFormat;
  }

  @computed
  get get_arr_selectedItems() {
    return this.arr_selectedItems;
  }

  @computed
  get isCsvSelectableAsFileFormat() {
    return this.exportTypeWithCsvExportAvailable.includes(this.selectedExportSubFunction);
  }

  @computed
  get getSelectedExportSubFunction() {
    return this.selectedExportSubFunction;
  }

  @computed
  get get_str_selectedImportItem() {
    return this.str_selectedImportItem;
  }

  @computed
  get get_str_selectedFrameworkId() {
    return this.str_selectedFrameworkId;
  }

  @computed
  get getExportCubesByCubeType() {
    return this.exportCubesByCubeType;
  }

  @computed
  get getSelectedCubeTypes() {
    return this.selectedCubeTypes;
  }

  @computed
  get getSelectedCubes() {
    const selectedCubeCodes = [...new Set(this.cubesOfSelectedFramework.filter(c => this.selectedCubes.includes(c.cubeId)).map(c => c.value))]
    return selectedCubeCodes;
  }

  @computed
  get getCubesOfSelectedFramework() {
    return this.cubesOfSelectedFramework;
  }

  @computed
  get isFrameworkSelectorOpen() {
    return this.frameworkSelectorOpen;
  }

  @computed
  get getBranchToOverrideWorkingBranch() {
    return this.branchToOverrideWorkingBranch;
  }

  @computed
  get getSelectedCubeHierarchyIds() {
    return this.selectedCubeHierarchyIds;
  }

  @computed
  get getCubeHierarchies() {
    return this.cubeHierarchies;
  }

  @computed
  get getSelectedFrameworks() {
    return this.selectedFrameworks
  }

  @computed
  get isAllFrameworkSelected() {
    return this.selectedFrameworks.length === this.arr_all_frameworks.length;
  }

  @computed
  get shouldIncludeMappingContent() {
    return this.includeMappingContent;
  }

  @computed
  get shouldIncludeRenderingContent() {
    return this.includeRenderingContent;
  }

  @computed
  get shouldIncludeTransformationContent() {
    return this.includeTransformationContent;
  }

  @computed
  get getOnlyCurrentlyValidMetadata() {
    return this.onlyCurrentlyValidMetadata;
  }

  @computed
  get isSelectedExportSubFunctionCanOnlyCurrentlyValidMetadata() {
    return (
      this.selectedExportSubFunction === ExportSubFunction.FRAMEWORKS_EXPORT ||
      this.selectedExportSubFunction === ExportSubFunction.FRAMEWORK_MATRIX_EXPORT ||
      this.selectedExportSubFunction === ExportSubFunction.INDIVIDUAL_CUBE_EXPORT
    );
  }

  @computed
  get isFrameworkSelectorDisabledForIndividualCubeExport() {
    return this.frameworkSelectorDisabledForIndividualCubeExport;
  }

  @computed
  get get_arr_entities() {
    try {
      if (this.arr_entities && this.arr_entities.length > 0) {
        return this.arr_entities;
      }
      return [];
    } catch (error) {
      console.log(error.message);
    }
    return [];
  }

  @computed
  get get_arr_frameworks() {
    return this.arr_all_frameworks;
  }

  @computed
  get get_str_modal_title() {
    return this.str_modal_title;
  }

  @computed
  get getDefaultFileFormatByExportType() {
    switch(this.selectedExportSubFunction) {
      case ExportSubFunction.ENTITY_EXPORT:
        return "csv"
      case ExportSubFunction.FRAMEWORKS_EXPORT:
        return "csv"
      case ExportSubFunction.FRAMEWORK_MATRIX_EXPORT:
        return "xlsx"
      case ExportSubFunction.INDIVIDUAL_CUBE_EXPORT:
        return "xlsx"
      default:
        return "xlsx"
    }
  }

  @computed
  get getReleaseForSelectedFramework() {
    const intermediateReleases = this.allReleasesOfFramework.filter(release => release.releaseType === "INTERMEDIATE");
    const finalReleases = this.allReleasesOfFramework.filter(release => release.releaseType === "FINAL");
    const sortedRelease = [this.DEFAULT_RELEASE_TO_BE_EXPORTED];

    if (this.selectedExportSubFunction === ExportSubFunction.FRAMEWORK_DELTA_COMPARISON) {
      const initialProductionOfFrameworkProjects = this.allReleasesOfFramework.filter(release =>  release.releaseType === "PRODUCTION");
      this.addReleasesToList(initialProductionOfFrameworkProjects, sortedRelease)
    }

    // add final releases
    if (finalReleases && finalReleases.length > 0) {
      sortedRelease.push({
        label: "FINAL RELEASES",
        value: 0,
        isDisabled: true
      });
  
      this.addReleasesToList(finalReleases, sortedRelease)
    }

    // add intermediate releases
    if (intermediateReleases && intermediateReleases.length > 0) {
        sortedRelease.push({
          label: "INTERMEDIATE RELEASES",
          value: 0,
          isDisabled: true
        });

        this.addReleasesToList(intermediateReleases, sortedRelease)
    }

    return sortedRelease;
  }

  addReleasesToList = (releases, accumulator) => {
    releases
      .map(release => this.mapReleaseToOptions(release))
      .forEach(releaseOpt => accumulator.push(releaseOpt))
  }

  mapReleaseToOptions = ({branchTid, releaseName, releaseDate}) => {
    return {
      branchTid: branchTid,
      label: releaseName,
      value: `${branchTid}-${releaseName}-${releaseDate}`,
      releaseDate: releaseDate
    }
  }

  @computed
  get getSelectedReleaseOfFramework() {
    if (EnvironmentUtils.isBirdApp()) {
      return this.DEFAULT_RELEASE_TO_BE_EXPORTED.branchTid
    }

    return this.selectedReleaseBranches?.length === 1 ? this.selectedReleaseBranches[0] : this.DEFAULT_RELEASE_TO_BE_EXPORTED.branchTid
  }
  
  @action
  handleSelectedReleaseOfFrameworkChange = (selectedReleaseObj) => {
    const releaseBranch = selectedReleaseObj ? selectedReleaseObj.branchTid : this.DEFAULT_RELEASE_TO_BE_EXPORTED.branchTid
    if (releaseBranch !== 1) {
      this.onlyCurrentlyValidMetadata = false;
      this.includeMappingContent = false;
      this.includeRenderingContent = false;
      this.includeTransformationContent = false;
    }
    this.selectedReleaseBranches = [releaseBranch]

    if (this.selectedExportSubFunction === ExportSubFunction.INDIVIDUAL_CUBE_EXPORT) {
      this.cubesOfSelectedFramework = []
      this.selectedCubes = []
      this.fetchCubesOfSelectedFramework(releaseBranch);
    } else if (this.selectedExportSubFunction === ExportSubFunction.FRAMEWORK_MATRIX_EXPORT) {
      this.cubeHierarchies = []
      this.selectedCubeHierarchyIds = [];
      this.fetchCubeHierarchies(this.str_selectedFrameworkId, releaseBranch);
    }
  }

  fetchFrameworkReleases = async (frameworkId) => {
    if (EnvironmentUtils.isSddApp() && frameworkId) {
      this.allReleasesOfFramework = await this.http.getFrameworkReleases(frameworkId)
    }
  }

  getReleaseDetailsByBranchTid = (branchTid) => {
    const foundRelease = this.allReleasesOfFramework.filter(fwRelease => fwRelease.branchTid === branchTid)

    return foundRelease?.length > 0 ? foundRelease[0] : {}
  }

  @computed
  get getValidOnDate() {
    return this.validOnDate;
  }

  @action
  setValidOnDate = (date) => {
    if (date) {
      this.validOnDate = new Date(date)
      this.onlyCurrentlyValidMetadata = true
    } else {
      this.validOnDate = null
      this.onlyCurrentlyValidMetadata = false
    }
  }
  @action
  setSelectedBranchData = (selectedBranchData) => {
      this.selectedBranchData = selectedBranchData
  }

  @computed
  get getSelectedBranchData() {
    return this.selectedBranchData
  }

  @computed
  get isValidityDateSelectorClearable() {
    if (ExportCategory.TECHNICAL.includes(this.selectedExportSubFunction)) {
      return true
    } else if (ExportCategory.SIMPLIFIED.includes(this.selectedExportSubFunction)) {
      // all simplfied exports must provide a validity date
      return false
    }

    return false
  }

  /**
   * handle export of individual cube export from the cube view (cube representation)
   */
  @action
  handleIndividualCubeViewExport = (cubeObj) => {
    this.changeSelectedExportSubFunction(ExportSubFunction.INDIVIDUAL_CUBE_VIEW_EXPORT);
    this.handleSelectedCubesChange(cubeObj);

    this.setValidOnDate(null);

    this.func_handleExportClick();
  }

  @computed
  get getValidityDatePickerPlaceholder() {
    if (ExportCategory.TECHNICAL.includes(this.selectedExportSubFunction)) {
      return "ALWAYS"
    } else if (ExportCategory.SIMPLIFIED.includes(this.selectedExportSubFunction)) {
      return "Today"
    }

    return "NOT SET"
  }

  getExportDescription = () => {
    return ExportDescription[this.selectedExportSubFunction];
  }

  @computed
  get getSelectedImportSubFunction() {
    return this.selectedImportSubFunction;
  }
  
  @action
  changeSelectedImportSubFunction = subFunction => {
    this.selectedImportSubFunction = subFunction;

    this.func_reset_settings();
    this.str_selectedFunction = "Import";

    // set no validity date by default
    this.setValidOnDate(null)
  };

  @action
  setFilesToImport = filesToImport => {
    this.filesToImport = filesToImport ?? [];
  };

  @computed
  get getIndividualCubeImportFramework() {
    return this.indivualCubeImportFrameworkObject ? 
      this.indivualCubeImportFrameworkObject.value : 
      this.arr_all_frameworks.find(fw => fw.fwId.toString() === this.selectedBranchData?.project?.frameworks)?.code;
  }

  @computed
  get getSelectedBranchId() {
    return (this.selectedBranchData?.branch?.tid)
  }
  
  @computed
  get getIndividualCubeImportMaintenanceAgencyId() {
     return this.selectedBranchData?.maintenanceAgency?.maintenanceAgencyId
  }

  @action
  handleChangeIndividualCubeImportFramework = selectedFrameworkObject => {
    this.indivualCubeImportFrameworkObject = selectedFrameworkObject
  };

  @computed
  get getAllFrameworks() {
    let filterValue = this.selectedBranchData?.project?.frameworks;
    
    return this.arr_all_frameworks
      .filter(item => {
        if (typeof filterValue === 'string') {
          return item.fwId.toString() === filterValue;
        } else if (Array.isArray(filterValue)) {
          return filterValue.includes(item.fwId.toString());
        }
        return false;
      })
      .map(fw => {
        return {
          label: fw.label,
          value: fw.code
        };
      });
  }
  

  @computed
  get getAllMaintenanceAgencies() {
    return this.allMaintenanceAgencies.map(ma => {
      return {
        label: ma.name,
        value: ma.maintenanceAgencyId
      }
    });
  }
  @computed
  get getActionsEventsTableData() {
    return this.actionsEventsTableData;
  }

  @action
  func_fetchActionsDataFromUser = () => {
    if (IS_BIRD_APP) return;
      this.obj_actionsEventsQueryFilter.filter.bid = {in: [this.getSelectedBranchId]}

      this.http.fetchActionsDataFromUser(this.obj_actionsEventsQueryFilter).then(
        action((data) => {
          if (data && data.results) {
            data.results.sort((a, b) => {
              return new Date(a.processingStart) -  new Date(b.processingStart) 
            });
            this.actionsEventsTableData = data;

          }
        })
      );
  };

  fetchAllMaintenanceAgencies = () => {
if (!this.allMaintenanceAgencies || this.allMaintenanceAgencies.length === 0) {
      this.http.service_fetch_ma().then(data => {
        this.allMaintenanceAgencies = data.results.map(ma => {
          return {
            name: ma.name,
            maintenanceAgencyId: ma.maintenanceAgencyId
          }
        })
      });
    }
  }
}
